import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { StripeElements, StripeCardElementOptions,StripeCardNumberElementOptions, StripeElementsOptions } from '@stripe/stripe-js';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import {
  StripeCardComponent, StripeCardCvcComponent, StripeCardExpiryComponent,
  StripeCardNumberComponent, StripeService
} from 'ngx-stripe';
import { loadStripe } from '@stripe/stripe-js';
import { BaseService, SettingsService, StorageService } from 'src/app/core/services';
import { SessionService } from 'src/app/core/services/session.service';
import { UpdatePaymentService } from 'src/app/core/services/update-payment.service';
import { Router } from '@angular/router';
import { environment } from 'src/environment';
import { payStripeCompleteIdealPaymentMethod } from 'src/app/shared/constants';
import { UikitService } from 'src/app/core/services/uikit.service';
import * as uikit from 'uikit';
@Component({
  selector: 'app-change-card-info',
  templateUrl: './change-card-info.component.html',
  styleUrls: ['./change-card-info.component.scss', '../modal-screens.scss']
})
export class ChangeCardInfoComponent implements OnInit {


  cardNumberValidation: any;
  cardCvvValidation: any;
  cardExpiryValidation: any;


  elements: StripeElements;
  stripeTest: any;
  cardValidation: any;
  paymentBtnDisabled: boolean;
  buttonValue: any;
  idealEmptyError = true;
  @ViewChild('name') inputName; 
  @ViewChild(StripeCardComponent) card;
  @ViewChild(StripeCardNumberComponent) cardNumber: StripeCardNumberComponent;
  @ViewChild(StripeCardExpiryComponent) cardExpiry: StripeCardExpiryComponent;
  @ViewChild(StripeCardCvcComponent) cardCVV: StripeCardCvcComponent;
  @Output() paymentUpdated = new EventEmitter<Boolean>();
  textColor = getComputedStyle(document.documentElement).getPropertyValue('--primary-font-color-on-lbg');
  bgColor =  getComputedStyle(document.documentElement).getPropertyValue('--bg-page');
  placeHolderColor = getComputedStyle(document.documentElement).getPropertyValue('--secondary-font-color');

  baseStyles: StripeCardElementOptions = {
    hidePostalCode: true,
    style: {
      base: {
        iconColor: '#666EE8',
        color: this.textColor,
        backgroundColor: this.bgColor,
        padding: '1px',
        lineHeight: '2.5',
        fontSize: '16px',
        '::placeholder': {
          color: this.placeHolderColor,
        },
      }
    }
  };
  cardOptions: StripeCardNumberElementOptions = {
    ...this.baseStyles,
    showIcon: true,
    iconStyle:'solid'
  };

  stripe: import("@stripe/stripe-js").Stripe;
  idealBank: import("@stripe/stripe-js").StripeIdealBankElement;

  elementsOptions: StripeElementsOptions = {
    locale: 'en',
  };

  sessionId: any;
  region: any;
  locale: any;
  paymentMethodType: any;
  payList: any;
  errorFound = false;
  errorResult: {};
  lastCode: any;
  payMethodLength: any;
  paymentType = 'card';
  proceedToPay = false;
  updateSuccess = false;
  proceedPayment: boolean = false;
  @Output() newItemEvent? = new EventEmitter<string>();
  skinName = environment.skinName;
  constructor(private fb: FormBuilder,private subscriptionService:SubscriptionService,private router: Router,
    public configService: ConfigurationService, private settingsService: SettingsService, 
    private storageService: StorageService, private sessionService: SessionService, private uikitService: UikitService,
    private updatePaymentService: UpdatePaymentService, private baseService: BaseService, private stripeService: StripeService) { 
    this.elementsOptions.locale = this.configService.stripeLocaleCode;
    }

  ngOnInit(): void {
    this.stripeTest = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
    });
    this.loadAllData();
    uikit.util.on(document, 'hide', '#change-payment-info', ()=>{
      if(this.updateSuccess)
        this.loadAllData();
      this.updateSuccess = false;
      this.stripeTest.controls.name.setValue('');
      this.stripeTest.controls.name.markAsUntouched();
      this.stripeTest.controls.name.markAsPristine();
      this.cardNumber?.element?.clear();
      this.cardExpiry?.element?.clear();
      this.cardCVV?.element?.clear();
    });
  }
  loadAllData() {
    this.setSesssionId();
    this.loadIdeal();
    this.updatePaymentDetails();
  }
  loadIdeal(){
    const options = {
      style: {
        base: {
          padding: '10px 12px',
          color: this.textColor,
          fontSize: '16px',
          backgroundColor: this.bgColor,
          lineHeight: '0.9',
          '::placeholder': {
            color: this.placeHolderColor
          },
        },
      },
    };
    const publishableKey = this.settingsService.stripeKey;
    loadStripe(publishableKey).then(res => {
      this.stripe = res;
      const stripeElement = this.stripe.elements({locale: this.elementsOptions.locale});
      this.idealBank = stripeElement.create('idealBank', options);
      this.idealBank.mount('#ideal-bank-element');
      this.idealBank.on('change', (event) => {
        this.idealEmptyError = event['empty'];
      });
    });
  }

  setSesssionId() {
    this.subscriptionService.updateMethodApi().subscribe((data) => {
      if (data) {
        this.sessionId = data.session_id;
      }
      this.baseService.loaderSource.next(false)
    });
  }


  updatePaymentDetails(){
    this.region = this.storageService.getLocalStore('region');
    this.locale = this.storageService.getLocalStore('locale');
    this.sessionService.validateSession(this.sessionId).subscribe((resp) => {
      if (resp.status_code === 200) {
        const data = resp.data;
        this.payList = data.stripe_payment_methods;
        this.paymentType = data.stripe_payment_methods ? data.stripe_payment_methods[0] : this.paymentType;
        this.payMethodLength = data.stripe_payment_methods?.length;
        this.errorFound = (data.already_subscribed || data.expired || data.invalid);
        this.errorResult = {
          already_subscribed: data.already_subscribed, expired: data.expired, invalid: data.invalid
        };
        if (!this.errorFound) {
          const fetchPaymentData = { region: this.region, locale: this.locale, session_id: this.sessionId };
          this.updatePaymentService.fetchPayement(fetchPaymentData).subscribe(data => {
            if (data) {
              this.paymentMethodType = data.payment_method_type
              this.lastCode = data.details.last4;
              this.baseService.loaderSource.next(false);
            }
          })
        } else {
          this.baseService.loaderSource.next(false);
        }
      } else {
        this.errorResult = {
          already_subscribed: false, expired: false, invalid: true
        };
        this.baseService.loaderSource.next(false);
      }
    })
  }


  cardPayItem(paymentId) {
    const createPaymentData = {
      locale: this.locale,
      region: this.region,
      payment_method: paymentId,
      session_id: this.sessionId
    }
    this.subscriptionService.createPayment(createPaymentData).subscribe(
      (resp) => {
        const data = resp;
        if (data.status) {
          if (data.setup_intent.status === "requires_source_action" || data.setup_intent.status === "requires_action") {
            const clientSecretKey = data.setup_intent.client_secret;
            const paymentMethod = paymentId
            this.confirmCardSetup(clientSecretKey, paymentMethod);
          }
          else {
            this.proceedToPay = false;
            this.updateSuccess = true;
            this.paymentUpdated.emit(true);
            this.uikitService.staticSuccessMessage(this.configService.localeKeys?.["plans.payment_updated.text"])
            //this.router.navigate(['/payment/update/method/success']);
          }
        } else {
          this.proceedToPay = false;
          this.uikitService.staticErrorMessage(this.configService.localeKeys?.["plans.payment_update_failed_alert.text"]);
        }
      }
    );
  }

  confirmCardSetup(clientSecretKey, paymentMethod) {
    this.stripeService.confirmCardSetup(clientSecretKey).subscribe(
      (response) => {
        this.proceedToPay = false;
        if (response.error) {
          this.baseService.loaderSource.next(false);
          this.uikitService.staticErrorMessage(this.configService.localeKeys?.["plans.payment_update_failed_alert.text"]);
        } else {
          const completeSubsData = {
            locale: this.locale, region: this.region, setupIntent: response.setupIntent.id,
            payment_method: paymentMethod, session_id: this.sessionId,
          };
          this.subscriptionService.completePayment(completeSubsData).subscribe(
            (resp) => {
              if (resp) {
                this.updateSuccess = true;
                this.paymentUpdated.emit(true);
                this.uikitService.staticSuccessMessage(this.configService.localeKeys?.["plans.payment_updated.text"])
                //this.router.navigate(['/payment/update/method/success']);
              }
            });
        }
      }
    );
  }
  idealPayItem() {
    const updateIdealPayData = {
      region: this.region, locale: this.locale,
      session_id: this.sessionId
    }
    this.subscriptionService.idealPayment(updateIdealPayData).subscribe(
      (resp) => {
        const data = resp.intent;
        const clientSecretKey = data.client_secret;
        const userContent = resp.user
        if (resp.status) {
          this.confirmIdealSetup(clientSecretKey, userContent);
        } else {
          this.proceedToPay = false;
          this.baseService.loaderSource.next(false);
        }
      }
    );
  }
  confirmIdealSetup(clientSecretKey: string, user) {
    const region = this.storageService.getLocalStore('region');
    const locale = this.storageService.getLocalStore('locale');
    let returnURL = `${environment.apiEndpoint + payStripeCompleteIdealPaymentMethod}?session_id=${this.sessionId}&region=${region}&locale=${locale}`;
    const paymentData = {
      payment_method: {
        ideal: this.idealBank,
        billing_details: {
          name: user.name,
          email: user.email
        },
      },
      return_url: returnURL
    };
    this.proceedToPay = false;
    this.stripe.confirmIdealSetup(clientSecretKey, paymentData)
      .then((result) => {
        this.baseService.loaderSource.next(false);
      })
      .catch((ex) => {
        this.baseService.loaderSource.next(false);
      });
  }

  payment(event) {
    // this.baseService.loaderSource.next(true);
    this.stripeTest.markAllAsTouched();
    event.preventDefault();
    let paymentData;
    if (this.paymentType === 'card') {
      paymentData = {
        type: 'card',
        card: this.cardNumber.element,
        billing_details: {
          name: this.stripeTest.get('name').value
        }
      };
    } else {
      this.proceedPayment = true;
    }
    if (this.paymentType === 'card') {
      // this.paymentBtnDisabled = true;
      this.stripeService.createPaymentMethod(paymentData).subscribe(
        (res: any) => {
          if (res.error) {
            if (res.code === 'incomplete_number') {
              this.cardNumberValidation = res;
            } else if (res.code === 'invalid_expiry_year_past') {
              this.cardExpiryValidation = res;
            } else if (res.code === 'incomplete_cvc') {
              this.cardCvvValidation = res;
            }
            this.paymentBtnDisabled = false;
          } else {
            this.proceedToPay = true;
            const paymentId = res.paymentMethod.id;
            this.cardPayItem(paymentId);
            this.newItemEvent.emit('');
          }
        });
    } else if (this.paymentType === 'ideal' && !this.idealEmptyError) {
      this.proceedToPay = true
      this.idealPayItem();
    } else {
      this.proceedToPay = false;
      this.baseService.loaderSource.next(false);
    }
  }

  selectPayment(type) {
    this.paymentType = type;
  }
  errorValidation(event) {
    if (event.elementType === 'cardNumber') {
      this.cardNumberValidation = event;
    } else if (event.elementType === 'cardExpiry') {
      this.cardExpiryValidation = event;
    } else if (event.elementType === 'cardCvc') {
      this.cardCvvValidation = event;
    }
  }
}
